module.exports = __webpack_public_path__ + "img/art-work-icon16.a811f0ce.png";